export const getDiscountValue = (total: number = 0, discount: number = 0) => {
  return (total * discount) / 100;
};

export const getTaxValue = (total: number, discount: number = 0, tax: number = 0) => {
  const discountValue = getDiscountValue(total, discount);
  return ((total - discountValue) * tax) / 100;
};

export const getTotalValue = (total: number = 0, discount: number = 0, tax: number = 0) => {
  const discountValue = getDiscountValue(total, discount);
  const taxValue = getTaxValue(total, discount, tax);
  return total - discountValue + taxValue;
};

export const getCreditUsed = (total: number = 0, totalCredits: number = 0) => {
  return total - totalCredits < 0 ? 0 : total - totalCredits;
};
